import buildItemComponent from "../../common/item-component-hoc"

import UserViewItemContainer from "./view/UserViewItemContainer"
import UserViewFormActionButtonsWidgetContainer from "./view/UserViewFormActionButtonsWidgetContainer"
import UserEditItemContainer from "./edit/UserEditItemContainer"
import UserEditFormActionButtonsWidgetContainer from "./edit/UserEditFormActionButtonsWidgetContainer"

const User = buildItemComponent("users", {
    view: [UserViewFormActionButtonsWidgetContainer, UserViewItemContainer],
    edit: [UserEditFormActionButtonsWidgetContainer, UserEditItemContainer]
})

export default User
